
import { useState } from "react";
import Otherproductmodal from "../../../Modal/Otherproductmodal";

const ImageGalleryComponent = ({ data }) => {
    const [selectedGalleryImage, setSelectedGalleryImage] = useState()
    const [showImageModal, setShowImageModal] = useState(false);

    const imageViewerModal = (e, item) => {
        e.preventDefault()
        setSelectedGalleryImage(item)
        setShowImageModal(!showImageModal);
    };

    return (
        <div className="uploadbannerblmdiv">
            <div className="uploadbannerdivnewmain">
                <div className="consttactdetatlsarroedyrdiv">
                    <p className="cinnattddttdtsttspo">Product Gallery</p>
                </div>
                <div className="uploadimagedivflx">
                    {Array.isArray(data?.gallery) &&
                        data.gallery.map((item, index) => {
                            return (
                                <div className="uploadimagebg" key={index}>
                                    <div className="uploadimagebgmain">
                                        <div className="cameralogodivimgabslt" style={{
                                            width: '100%',
                                            maxWidth: '100%',
                                            minWidth: '100%',
                                            height: '100%',
                                            padding: 0,
                                        }}>
                                            <div className="cameralogodivimg"
                                                onClick={(e) => imageViewerModal(e, item)}
                                                style={{
                                                    width: "100%",
                                                    maxWidth: '100%',
                                                    minWidth: '100%',
                                                    height: '100%',
                                                }}>
                                                <img
                                                    style={{
                                                        cursor: "pointer",
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: "10px",
                                                    }}
                                                    src={item?.image}
                                                    alt="..."
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <p
                                        className="imagetitrtlstrtrxpp"
                                        onClick={(e) => imageViewerModal(e, item)}
                                        style={{
                                            cursor: "pointer"
                                        }}
                                    >
                                        {item?.title}
                                    </p>
                                </div>
                            );
                        })}

                </div>
            </div>
            {showImageModal && (
                <Otherproductmodal closemodal={setShowImageModal} data={selectedGalleryImage} />
            )}
        </div>
    );
}
export default ImageGalleryComponent;